<template>
  <v-dialog
    v-model="dialog"
    width="500"
    height="350"
    @keydown.13="okPushed()"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :title="title"
        :disabled="disabled"
        v-on="on"
      >
        <v-icon>
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="model"
          :label="placeholder"
          :color="color"
          :rules="[rules.required, rules.regex]"
          autofocus
          @focus="$event.target.select()"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="!isValid"
          @click="okPushed"
        >
          {{ $t("dialog.ok") }}
        </v-btn>
        <v-btn
          text
          @click="cancelPushed"
        >
          {{ $t("dialog.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    openDialog: {
      type: Boolean,
      default: false,
    },
    nameFile: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
      model: "",
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        regex: (value) => /^[^/\\?*><|:"']*$/.test(value) || this.$t("field.filename"),
      },
    };
  },
  computed: {
    isValid: {
      get() {
        if (this.rules.required(this.model) === true && this.rules.regex(this.model) === true) {
          return true;
        } else {
          return false;
        }
      },
    },
  },
  watch: {
    openDialog: function (val) {
      this.dialog = val;
    },
    nameFile: function (val) {
      this.model = val;
    },
  },
  methods: {
    okPushed() {
      if (this.model.length > 0) {
        this.$emit("ok-pushed", this.model);
        this.model = "";
        this.dialog = false;
      }
    },
    cancelPushed() {
      this.$emit("cancel-pushed");
      this.model = "";
      this.dialog = false;
    },
  },
};
</script>

<style></style>
